import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "3435c59d-4542-4625-8500-7cac73c3503e", content: "Categorical scale", options: {} },
  { id: "d88952b3-728f-47f2-9895-858e56139bb9", content: "Exponential scale", options: {} },
  { id: "ea77aab2-7f89-418d-a15b-53e8e5a9ed4d", content: "Ordinal scale", options: {} },
  { id: "e76feedc-a7aa-44dc-ab7d-e1b34d67d09c", content: "Continuous scale", options: {} },
];

export const task: Task = {
  id: "00596448-8d97-47c7-8500-06c8359c9a93",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["d88952b3-728f-47f2-9895-858e56139bb9"],
};
